import { render, staticRenderFns } from "./svg-icon-me.vue?vue&type=template&id=4f97d6d8&"
import script from "./svg-icon-me.vue?vue&type=script&lang=js&"
export * from "./svg-icon-me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports